export default "__VITE_ASSET__4f9e94b3__"